import CommentIcon from "@mui/icons-material/Comment";
import { Box, IconButton } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import { useState } from "react";
import { ViewNotesModal } from "./ViewNotesModal";

type Props = ICellRendererParams & {
	value: string | null;
};

export const NotesCell = ({ value, data }: Props) => {
	const [showModal, setShowModal] = useState(false);
	const hasNotes = value && value.trim() !== "";

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "100%",
				width: "100%",
			}}
		>
			<IconButton
				onClick={() => hasNotes && setShowModal(true)}
				disabled={!hasNotes}
				size="small"
				sx={{
					padding: "2px",
					cursor: hasNotes ? "pointer" : "default",
				}}
			>
				<CommentIcon color={hasNotes ? "primary" : "disabled"} />
			</IconButton>
			<ViewNotesModal
				open={showModal}
				onClose={() => setShowModal(false)}
				notes={value || ""}
				partNumber={data?.PartNumber || ""}
			/>
		</Box>
	);
};
